import { render } from "./ComparisonStoresTableSettings.vue?vue&type=template&id=35aaf623&scoped=true"
import script from "./ComparisonStoresTableSettings.vue?vue&type=script&lang=js"
export * from "./ComparisonStoresTableSettings.vue?vue&type=script&lang=js"

import "./ComparisonStoresTableSettings.vue?vue&type=style&index=0&id=35aaf623&lang=scss&scoped=true"
import "./ComparisonStoresTableSettings.vue?vue&type=style&index=1&id=35aaf623&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aaf623"]])

export default __exports__